import {
  Alert,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormHelperText,
  IconButton,
  OutlinedInput,
  Paper,
  Radio,
  RadioGroup,
  Stack,
  Tooltip,
  Typography,
  styled
} from '@mui/material';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { FC, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useUser } from 'src/components/hooks/useUser';
import { useGetCodeListDataQuery, useGetIpTreatmentsQuery } from 'src/services/codeList';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { useSiteContactInfo } from '../steps/useSitecontactinfo';
import { clearMessage, setMessage } from 'src/store/Message';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { useFieldTranslation } from '../../fields/useFieldTranslation';
import { useIPManagement } from './useIPManagement';
import AddIcon from '@mui/icons-material/Add';
import { PopupComponent } from 'src/components/common/PopupComponent';
import DeleteIcon from '@mui/icons-material/Delete';
import { hideLoader, showLoader } from 'src/store/Loader';
import { archLevel } from 'src/data/config';
import ESignConsentReAuth from 'src/components/common/ESignConsentReAuth';
import { useLazySetESignQuery } from 'src/services/ESignAPI';
import { useSelectedAppInfo } from 'src/util/SelectedAppInfo';
import { useValidUserForReAuth } from 'src/components/hooks/useValidUserForReAuth';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import { UI_TIME_ZONE } from 'src/constants/formats';
import printPdfWithViewer from 'src/components/common/PrintPdfWithViewer';
import { useGetPharmacyListMutation } from 'src/services/workarea';
import { sendRequest } from 'src/hooks/useFetch';
import { setNewResupplyOrder, setOpenResupplyOrderPage, setSelectedResupply } from 'src/store/drugSupplySlice';
import { useUtil } from 'src/components/hooks/useUtil';
import IpMangementSubmitModal from './Submit';
import AppModal from 'src/components/modal';
const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary
}));

interface IPharmacyDetails {
  pharm_name: string;
  pharm_id: string;
  pharm_nick_name: string;
  pharm_street_address: string;
  pharm_street_address2: string;
  pharm_city: string;
  pharm_country: string;
  pharm_zip_code: string;
  primary_pharmacy: boolean;
}
const IpSupplyOrderpage: FC<any> = ({
  isSubmitted,
  setIsIPSupplySaved,
  isSignsCompleted,
  setIsSignsCompleted,
  isIpReleaseCertified,
  setIsSignsCompletedLegacy,
  isIPSupplyChanged,
  setIsSupplyChanged
}) => {
  const { ipSupplyOrder } = useFieldTranslation();
  const initialState = {
    pharm_name: '',
    pharm_id: null,
    pharm_nick_name: '',
    pharm_add_same_as_site: 'NA',
    pharm_street_address: '',
    pharm_street_address2: '',
    pharm_city: '',
    pharm_country: '',
    pharm_zip_code: '',
    ip_quantity_needed: 0,
    ip_quantity_on_site: 0,
    ip_overnight: 'N',
    ip_delivery_date: null,
    ip_requested_by: '',
    quantity_units: '',
    ip_requested_date: null,
    ip_ordered_by: '',
    ip_ordered_date: null,
    ip_sign_personnel: '',
    ip_open_label: null
  };
  const { isValidUserForReAuth } = useValidUserForReAuth();
  const [openSignConsent, setOpenSignConsent] = useState(false);
  const [signControlObject, setSignControlObject] = useState({
    is_receivedby_sign: false,
    is_reviewedby_sign: false,
    is_site_sign: false
  });
  const { applicationModuleSection } = useFieldTranslation();
  const { selectedAppSection } = useSelectedAppInfo();
  const { getPreferredDateTimeInLocal, userPreferedDateFormat, getServerDateOrInvalidDayJs } = usePreferedDateFormat();
  const { showError } = useUtil();
  const datePickerInputFormat = userPreferedDateFormat.toUpperCase();

  const [supplyOrder, setSupplyOrder] = useState<any>(initialState);
  const [supplyDetails, setSupplyDetails] = useState<any>({});
  const [getRequestedBy, setRequestBy] = useState<any>({});
  const [getOrderBy, setOrderBy] = useState<any>({});
  const [pharmacyAddressList, setPharmacyAddressList] = useState<IPharmacyDetails[]>();
  const [primaryPharmacyData, setPrimaryPharmacyData] = useState<any>([]);
  const [pharmacyDropdownName, setPharmacyDropdownName] = useState('');
  const [tempPharmDropdownName, setTempPharmDropdownName] = useState('');
  const [isUpdate, setIsUpdate] = useState(false);
  const [context, setContext] = useState(false);
  const [openPharmaConfirmation, setOpenPharmaConfirmation] = useState(false);
  const [ipDeliveryDateError, setipDeliveryDateError] = useState(false);
  const [ipRequestedDate, setIpRequestedDate] = useState(false);
  const [ipOrderedDate, setipOrderedDate] = useState(false);
  const [treatmentNo, setTreatmentNo] = useState([]);
  const { checkPermission } = usePermissionWrapper();
  const perDisable = checkPermission('update_ip_supply_order');
  const dispatch = useDispatch();
  const dispatchApp = useAppDispatch();
  const studyId: any = useAppSelector((state: any) => state.site.selectedStudy);
  const selectedCountry = useAppSelector((state: any) => state.site.selectedCountry);
  const selectedSite = useAppSelector((state: any) => state.site.selectedSite);
  const { user } = useUser();
  const { ipmInvalidDateErrorMsg, ipmDataUpdateSuccessMsg } = useFieldTranslation();
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [removeIpID, setRemoveIpID] = useState<any>('');
  const { getSiteStudyPersonnelQueryData } = useSiteContactInfo();
  const [siteSubmitSuccess, setSiteSubmitSuccess] = useState<boolean>(false);

  const initialIPDrugDetail = {
    investigational_drug: '',
    isErrorIPDrug: false,
    unit: '',
    isErrorUnit: false,
    ip_quantity_needed: null,
    isErrorIPQtyNeeded: false,
    ip_quantity_on_site: null,
    isErrorIPQtyOnsite: false
  };
  const [ipDrugDetails, setIpDrugDetails] = useState<any>([initialIPDrugDetail]);

  const [drugNames, setDrugNames] = useState<any>([]);
  const sponsorApp = archLevel === 'sponsor';
  const disableIpSupplyOprder = sponsorApp || !isIpReleaseCertified;
  const { handleError } = useUtil();
  const isNewResupply = useAppSelector(state => state.drugSupplySlice.newResupplyorder);
  const openResupplyOrder = useAppSelector(state => state.drugSupplySlice.openResupplyOrderPage);
  const selectResupplyData: any = useAppSelector(state => state.drugSupplySlice.selectedResupply);
  const { selectedApp } = useSelectedAppInfo();
  const currentApp = selectedApp === process.env.REACT_APP_STUDYCONDUCT_SLUG ? 'CONDUCT' : 'STARTUP';
  const [disableSign, setDisableSign] = useState(false);
  const [openSubmitModal, setOpenSubmitModal] = useState<boolean>(false);
  const [openSponsorSubmitModal, setOpenSponsorSubmitModal] = useState<boolean>(false);
  const {
    studySitePersonnelQueryData,
    getStudySitePersonnelQueryData,
    getIpSupplyDetailsQueryData,
    ipSupplyDetailsQueryData,
    getIpSupplyOrderQueryData,
    ipSupplyOrderQueryData,
    getIpSupplyOrderError,
    updateIpSupplyOrder,
    updateIpSupplyOrderError,
    updateIpSupplyOrderSuccess,
    createIpSupplyOrder,
    getIpSupplyOrderIsError,
    updateIpSupplyOrderIsError,
    createIpSupplyOrderIsError,
    createIpSupplyOrderError,
    createIpSupplyOrderIsSuccess,
    drugNameDetailsQueryData = [],
    getDrugNameDetailsQueryData,
    getIpSupplyDetailsLoading,
    getIpSupplyOrderLoading,
    updateIpSupplyOrderLoading,
    createIpSupplyOrderLoading,
    getIpSupplyOrderSucess,
    getdownloadCSVLoading,
    getdownloadCSVIsError,
    getdownloadCSVError,
    selectIpResupply,
    selectIpResupplyData,
    selectIpResupplyIsSuccess,
    updateIpResupplyOrder,
    updateIpResupplyOrderLoading,
    updateIpResupplyOrderIsError,
    updateIpResupplyOrderError,
    updateIpResupplyOrderSuccess,
    approveSubmitIPSuply,
    approveSubmitIsSuccess
  } = useIPManagement();
  const selectIpResupplyFunc = () => {
    selectIpResupply({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      ip_supply_id: selectResupplyData?.id,
      application: archLevel === 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP,
      application_section: currentApp
    });
  };
  const { data: GetIpTreatmentsData } = useGetIpTreatmentsQuery({ study_id: studyId });
  const [setESignature] = useLazySetESignQuery();
  const { data } = useGetCodeListDataQuery('IPKUNIT');
  const [equipmentData, setequipmentData] = useState<any>([]);
  useEffect(() => {
    if (data) {
      setequipmentData(data.map((ele: any) => ele.code_list_value));
    }
  }, [data]);

  const [pharmNameIsError, setPharmNameIsError] = useState(false);
  const [getPharmacyList, { data: pharmacyListData }] = useGetPharmacyListMutation();
  useEffect(() => {
    if (pharmacyListData) {
      const tempPharmacyList = pharmacyListData.map((ele: any) => {
        return {
          pharm_name: ele.pharmacy_name,
          pharm_id: ele.id,
          pharm_nick_name: ele.pharmacy_nick_name,
          pharm_street_address: ele.pharmacy_address1,
          pharm_street_address2: ele.pharmacy_address2,
          pharm_city: ele.pharmacy_city,
          pharm_country: ele.pharmacy_country,
          pharm_zip_code: ele.pharmacy_zipcode,
          primary_pharmacy: ele.primary_pharmacy
        };
      });
      const nonPrimaryList: any = tempPharmacyList.filter((pharm: any) => !pharm.primary_pharmacy);
      const primaryPharmacyObj: any = tempPharmacyList.filter((pharm: any) => pharm.primary_pharmacy);
      setPrimaryPharmacyData(primaryPharmacyObj.length > 0 ? primaryPharmacyObj : []);
      const otherPharmObj: any = {
        pharm_name: 'Other',
        pharm_id: null,
        pharm_nick_name: '',
        pharm_street_address: '',
        pharm_street_address2: '',
        pharm_city: '',
        pharm_country: '',
        pharm_zip_code: ''
      };
      if (nonPrimaryList.length > 0) {
        setPharmacyAddressList([...nonPrimaryList, otherPharmObj]);
      } else {
        setPharmacyAddressList([otherPharmObj]);
      }
    }
  }, [pharmacyListData]);
  useEffect(() => {
    if (drugNameDetailsQueryData && drugNameDetailsQueryData?.length) {
      setDrugNames(drugNameDetailsQueryData);
    }
  }, [drugNameDetailsQueryData]);

  useEffect(() => {
    if (GetIpTreatmentsData) {
      setTreatmentNo(GetIpTreatmentsData?.toString());
    }
  }, [GetIpTreatmentsData]);

  const handleCheck = (e: any) => {
    const data = e.target.value;
    if (data === 'Y' && e.target.name === 'ip_overnight') {
      setSupplyOrder({ ...supplyOrder, [e.target.name]: data, ip_delivery_date: null });
    } else if (e.target.name === 'ip_ordered_by') {
      setSupplyOrder({ ...supplyOrder, [e.target.name]: data, ip_sign_personnel: null });
    } else if (e.target.name === 'ip_quantity_needed' || e.target.name === 'ip_quantity_on_site') {
      if (e.target.value && e.target.value.length < 4) {
        setSupplyOrder({ ...supplyOrder, [e.target.name]: data, site_id: selectedSite, study_id: studyId });
      }
    } else if (data === 'Yes' && e.target.name === 'ip_open_label') {
      setSupplyOrder({
        ...supplyOrder,
        [e.target.name]: data,
        site_id: selectedSite,
        study_id: studyId,
        treatment_number: treatmentNo.toString()
      });
    } else if (data === 'No' && e.target.name === 'ip_open_label') {
      setSupplyOrder({
        ...supplyOrder,
        [e.target.name]: data,
        site_id: selectedSite,
        study_id: studyId,
        treatment_number: null
      });
    } else {
      setSupplyOrder({ ...supplyOrder, [e.target.name]: data, site_id: selectedSite, study_id: studyId });
    }
    if (pharmacyDropdownName === 'Other' && e.target.name === 'pharm_name' && !data) {
      setPharmNameIsError(true);
    } else {
      setPharmNameIsError(false);
    }
    setIsSupplyChanged(true);
    setIsIPSupplySaved(false);
    setConfirmExitValue(dispatch, true);
  };

  const setSelectedPharmacyDetails = (pharmacyName: string) => {
    const updatedPharmacyDetails: any = pharmacyAddressList?.find(
      (pharmacy: IPharmacyDetails) => pharmacy.pharm_name === pharmacyName
    );
    setPharmacyDropdownName(updatedPharmacyDetails?.pharm_name);
    setSupplyOrder({
      ...supplyOrder,
      pharm_name: updatedPharmacyDetails?.pharm_name !== 'Other' ? updatedPharmacyDetails?.pharm_name : '',
      pharm_id: updatedPharmacyDetails?.pharm_id,
      pharm_nick_name: updatedPharmacyDetails?.pharm_nick_name,
      pharm_street_address: updatedPharmacyDetails?.pharm_street_address,
      pharm_street_address2: updatedPharmacyDetails?.pharm_street_address2,
      pharm_city: updatedPharmacyDetails?.pharm_city,
      pharm_country: updatedPharmacyDetails?.pharm_country,
      pharm_zip_code: updatedPharmacyDetails?.pharm_zip_code
    });
  };

  const onPharmacyNameChange = (event: any) => {
    if (pharmacyDropdownName) {
      setTempPharmDropdownName(event.target.value);
      setOpenPharmaConfirmation(true);
    } else {
      setSelectedPharmacyDetails(event.target.value);
    }
    setPharmNameIsError(false);
    setIsSupplyChanged(true);
    setIsIPSupplySaved(false);
    setConfirmExitValue(dispatch, true);
  };

  const setPrimaryPharmacyDetails = () => {
    setPharmacyDropdownName(primaryPharmacyData[0]?.pharm_name || '');
    setSupplyOrder({
      ...supplyOrder,
      pharm_name: primaryPharmacyData[0]?.pharm_name,
      pharm_id: primaryPharmacyData[0]?.pharm_id,
      pharm_nick_name: primaryPharmacyData[0]?.pharm_nick_name,
      pharm_street_address: primaryPharmacyData[0]?.pharm_street_address,
      pharm_street_address2: primaryPharmacyData[0]?.pharm_street_address2,
      pharm_city: primaryPharmacyData[0]?.pharm_city,
      pharm_country: primaryPharmacyData[0]?.pharm_country,
      pharm_zip_code: primaryPharmacyData[0]?.pharm_zip_code,
      pharm_add_same_as_site: 'Y'
    });
    setConfirmExitValue(dispatch, true);
    setIsSupplyChanged(true);
  };

  const handleRadio = (e: any) => {
    if (e.target.value === 'Y') {
      if (pharmacyDropdownName === '') {
        setPrimaryPharmacyDetails();
      } else {
        setContext(true);
      }
    } else if (e.target.value === 'N') {
      setPharmacyDropdownName('');
      setContext(false);
      setSupplyOrder({
        ...supplyOrder,
        pharm_add_same_as_site: 'N',
        pharm_name: '',
        pharm_id: null,
        pharm_nick_name: '',
        pharm_street_address: '',
        pharm_street_address2: '',
        pharm_city: '',
        pharm_country: '',
        pharm_zip_code: ''
      });
      setConfirmExitValue(dispatch, true);
      setIsSupplyChanged(true);
    }
    setIsSupplyChanged(true);
  };

  const handleIPOrderBySign = async (data: any = {}) => {
    if (data.success) {
      if (!isValidUserForReAuth(data.records.user_name)) {
        dispatch(setMessage({ msgDetails: `Please e-sign with the logged in username`, severity: 'error' }));
      } else {
        setOpenSignConsent(false);
        dispatch(showLoader());
        let dataObj: any = {
          username: data.records.user_name,
          password: data.records.password,
          module_name: applicationModuleSection.ipManagement,
          name_of_signature: '',
          name_of_date_field: '',
          columns_to_change: {}
        };
        if (signControlObject.is_receivedby_sign) {
          dataObj = {
            ...dataObj,
            id: supplyOrder?.id,
            name_of_signature: 'ip_sponsor_received_by',
            name_of_date_field: 'ip_sponsor_received_date',
            columns_to_change: {
              ...dataObj.columns_to_change,
              ip_sponsor_received_signature_reason: data.records.sign_reason,
              ip_sponsor_received_signature: user,
              updated_by: user
            }
          };
        } else if (signControlObject.is_reviewedby_sign) {
          dataObj = {
            ...dataObj,
            id: supplyOrder?.id,
            name_of_signature: 'ip_sponsor_reviewed_by',
            name_of_date_field: 'ip_sponsor_reviewed_date',
            columns_to_change: {
              ...dataObj.columns_to_change,
              ip_sponsor_reviewed_signature_reason: data.records.sign_reason,
              ip_sponsor_reviewed_signature: user,
              updated_by: user
            }
          };
        } else if (signControlObject.is_site_sign) {
          dataObj = {
            ...dataObj,
            name_of_signature: 'ip_site_signed_by',
            name_of_date_field: 'ip_site_signed_date',
            columns_to_change: {
              ...dataObj.columns_to_change,
              ip_site_signature_reason: data.records.sign_reason,
              ip_site_signature: user,
              updated_by: user
            },
            id: supplyOrder?.id
          };
        }
        const signatureResponse: any = await setESignature({
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry,
          application: archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP,
          application_section: selectedAppSection,
          application_module_section: applicationModuleSection.ipManagement,
          data: dataObj
        });
        if (signatureResponse.isSuccess) {
          openResupplyOrder ? selectIpResupplyFunc() : getIpSupplyOrderQueryData();
          setSignControlObject({
            is_receivedby_sign: false,
            is_reviewedby_sign: false,
            is_site_sign: false
          });
          dispatch(
            setMessage({
              msgDetails: 'Sign Completed',
              severity: 'success'
            })
          );
        } else {
          dispatch(setMessage({ msgDetails: `Authorization for ${data.records.user_name} failed`, severity: 'error' }));
        }
        dispatch(hideLoader());
      }
    }
  };

  const handleReceivedBySignature = async () => {
    setOpenSignConsent(true);
    setSignControlObject({
      ...signControlObject,
      is_receivedby_sign: true,
      is_reviewedby_sign: false,
      is_site_sign: false
    });
  };
  const handleReviewedBySignature = async () => {
    setOpenSignConsent(true);
    setSignControlObject({
      ...signControlObject,
      is_receivedby_sign: false,
      is_reviewedby_sign: true,
      is_site_sign: false
    });
  };

  useEffect(() => {
    getPharmacyList({
      study_id: studyId,
      site_id: selectedSite,
      application: archLevel === 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP
    });
  }, [selectedSite]);

  useEffect(() => {
    if (studySitePersonnelQueryData) {
      setOrderBy(studySitePersonnelQueryData);
      setRequestBy(studySitePersonnelQueryData);
    }
  }, [studySitePersonnelQueryData]);

  useEffect(() => {
    getDataPersonnelData();
  }, [selectedSite]);

  useEffect(() => {
    if (ipSupplyDetailsQueryData) {
      setSupplyDetails(ipSupplyDetailsQueryData);
    }
  }, [ipSupplyDetailsQueryData]);

  useEffect(() => {
    if (siteSubmitSuccess) {
      selectIpResupplyFunc();
      window.scrollTo(0, 0);
    }
  }, [siteSubmitSuccess]);

  const getDataPersonnelData = async () => {
    await getSiteStudyPersonnelQueryData({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application: process.env.REACT_APP_NAME,
      site_users: true,
      strictly_site_users: true
    });
  };

  const getDownLoadCSV = async () => {
    dispatch(showLoader());
    try {
      const options = {
        pathVariables: {
          country: selectedCountry,
          application: process.env.REACT_APP_NAME,
          application_section: currentApp
        },
        site_id: selectedSite,
        study_id: studyId,
        ip_supply_id: currentApp === 'STARTUP' ? ipSupplyOrderQueryData.id : selectResupplyData?.id
      };
      const downloadedData: any = await sendRequest('getDownloadIPSupplyOrder', options);
      if (downloadedData.length > 0) {
        const blob = new Blob([downloadedData], { type: 'text/csv;charset=utf-8;' });
        const url = window.URL.createObjectURL(blob);
        const link: any = document.createElement('a');
        const fileName: any = currentApp === 'STARTUP' ? 'IP Supply Order' : 'IP Resupply Order';
        const ordernumber: any =
          currentApp === 'STARTUP' ? ipSupplyOrderQueryData?.order_number : selectIpResupplyData?.order_number;
        link.href = url;
        link.setAttribute('download', `${fileName} ${ordernumber}.csv`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    } catch (e: any) {
      dispatch(setMessage({ msgDetails: `Error while downloading CSV`, severity: 'error' }));
    }
    dispatch(hideLoader());
  };

  useEffect(() => {
    if (getdownloadCSVIsError || updateIpResupplyOrderIsError) {
      const err: any = getdownloadCSVError || updateIpResupplyOrderError;
      handleError(err);
    }
  }, [getdownloadCSVIsError, updateIpResupplyOrderIsError]);

  useEffect(() => {
    if (!isNewResupply || !openResupplyOrder) {
      if (ipSupplyOrderQueryData) {
        setSupplyOrder({
          ...ipSupplyOrderQueryData,
          ip_open_label:
            ipSupplyOrderQueryData.ip_open_label && ipSupplyOrderQueryData.ip_open_label !== null
              ? 'Yes'
              : !ipSupplyOrderQueryData.ip_open_label && ipSupplyOrderQueryData.ip_open_label !== null
              ? 'No'
              : null
        });
        let drugDetails = [];
        if (ipSupplyOrderQueryData?.investigational_drug_details.length) {
          drugDetails = ipSupplyOrderQueryData?.investigational_drug_details.map((details: any) => {
            return {
              ...details,
              isErrorIPDrug: false,
              isErrorUnit: false,
              isErrorIPQtyNeeded: false,
              isErrorIPQtyOnsite: false
            };
          });
        }
        const savedPharmName: string =
          ipSupplyOrderQueryData?.pharm_id !== null
            ? ipSupplyOrderQueryData?.pharm_name
            : ipSupplyOrderQueryData?.pharm_name !== null && ipSupplyOrderQueryData?.pharm_name !== ''
            ? 'Other'
            : '';
        setPharmacyDropdownName(savedPharmName);
        setIpDrugDetails(drugDetails.length > 0 ? drugDetails : [initialIPDrugDetail]);
        if (ipSupplyOrderQueryData.study_id === studyId) {
          setIsUpdate(true);
        }
        setIsSignsCompleted(
          ipSupplyOrderQueryData.ip_sponsor_received_by && ipSupplyOrderQueryData.ip_sponsor_reviewed_by
        );
        setIsSignsCompletedLegacy(
          ipSupplyOrderQueryData.ip_sponsor_received_by || ipSupplyOrderQueryData.ip_sponsor_reviewed_by
        );
        ipSupplyOrderQueryData?.ip_site_signed_by ? setDisableSign(false) : setDisableSign(true);
        setIsIPSupplySaved(true);
      }
    }
  }, [ipSupplyOrderQueryData, getIpSupplyOrderSucess]);

  useEffect(() => {
    if (!isNewResupply || openResupplyOrder) {
      if (selectIpResupplyData) {
        setSupplyOrder({
          ...selectIpResupplyData,
          ip_open_label:
            selectIpResupplyData.ip_open_label && selectIpResupplyData.ip_open_label !== null
              ? 'Yes'
              : !selectIpResupplyData.ip_open_label && selectIpResupplyData.ip_open_label !== null
              ? 'No'
              : null
        });
        let drugDetails = [];
        if (selectIpResupplyData?.investigational_drug_details.length) {
          drugDetails = selectIpResupplyData?.investigational_drug_details.map((details: any) => {
            return {
              ...details,
              isErrorIPDrug: false,
              isErrorUnit: false,
              isErrorIPQtyNeeded: false,
              isErrorIPQtyOnsite: false
            };
          });
        }
        const savedPharmName: string =
          selectIpResupplyData?.pharm_id !== null
            ? selectIpResupplyData?.pharm_name
            : selectIpResupplyData?.pharm_name !== null && selectIpResupplyData?.pharm_name !== ''
            ? 'Other'
            : '';
        setPharmacyDropdownName(savedPharmName);
        setIpDrugDetails(drugDetails);
        if (selectIpResupplyData.study_id === studyId) {
          setIsUpdate(true);
        }
        setIsSignsCompleted(selectIpResupplyData.ip_sponsor_received_by && selectIpResupplyData.ip_sponsor_reviewed_by);
        setIsSignsCompletedLegacy(
          selectIpResupplyData.ip_sponsor_received_by || selectIpResupplyData.ip_sponsor_reviewed_by
        );
        selectIpResupplyData?.order_number ? setDisableSign(false) : setDisableSign(true);
        setIsIPSupplySaved(true);
        if (archLevel === 'site' && selectIpResupplyData?.order_number) {
          window.scrollTo(0, 0);
        }
        if (archLevel === 'sponsor' && selectIpResupplyData?.is_sponsor_approved) {
          window.scrollTo(0, 0);
        }
      }
    }
  }, [selectIpResupplyData, selectIpResupplyIsSuccess]);

  useEffect(() => {
    if (getIpSupplyOrderError) {
      setSupplyOrder(initialState);
      setIsIPSupplySaved(false);
      setIpDrugDetails([initialIPDrugDetail]);
      setDisableSign(true);
    }
  }, [getIpSupplyOrderError]);

  useEffect(() => {
    getDrugNameDetailsQueryData();
    return () => {
      dispatch(setOpenResupplyOrderPage(false));
      dispatch(setNewResupplyOrder(false));
      dispatch(setSelectedResupply({}));
    };
  }, []);

  const handleSave = () => {
    let validation = true;
    if (
      supplyOrder.ip_delivery_date === 'Invalid Date' ||
      supplyOrder.ip_requested_date === 'Invalid Date' ||
      supplyOrder.ip_ordered_date === 'Invalid Date'
    ) {
      dispatchApp(
        setMessage({
          msgDetails: `${ipmInvalidDateErrorMsg} (${userPreferedDateFormat.toUpperCase()})`,
          severity: 'error'
        })
      );
      supplyOrder.ip_delivery_date === 'Invalid Date' ? setipDeliveryDateError(true) : setipDeliveryDateError(false);
      supplyOrder.ip_requested_date === 'Invalid Date' ? setIpRequestedDate(true) : setIpRequestedDate(false);
      supplyOrder.ip_ordered_date === 'Invalid Date' ? setipOrderedDate(true) : setipOrderedDate(false);
      validation = false;
    }
    if (ipDrugDetails && ipDrugDetails.length) {
      let isError = false;
      const investiGationalDrugs = ipDrugDetails;
      investiGationalDrugs.map((ele: any) => {
        if (ele.investigational_drug == '' || ele.investigational_drug == null) {
          ele.isErrorIPDrug = true;
          isError = true;
        }
        if (ele.unit == '' || ele.unit == null) {
          ele.isErrorUnit = true;
          isError = true;
        }
        if (ele.ip_quantity_needed == '' || ele.ip_quantity_needed == null) {
          ele.isErrorIPQtyNeeded = true;
          isError = true;
        }
        if (ele.ip_quantity_on_site == '' || ele.ip_quantity_on_site == null) {
          ele.isErrorIPQtyOnsite = true;
          isError = true;
        }
      });
      if (isError) {
        setIpDrugDetails([...investiGationalDrugs]);
        setIsIPSupplySaved(false);
        validation = false;
      }
    }

    if (!supplyOrder.pharm_id && pharmacyDropdownName === 'Other' && !supplyOrder.pharm_name) {
      setPharmNameIsError(true);
      setIsIPSupplySaved(false);
      validation = false;
    } else {
      setPharmNameIsError(false);
    }
    if (validation) {
      postData();
      setConfirmExitValue(dispatch, false);
    }
  };

  const postData = async () => {
    let invDrugDetails = [];
    if (ipDrugDetails.length) {
      invDrugDetails = ipDrugDetails.map((details: any) => {
        return {
          id: details.id,
          investigational_drug: details.investigational_drug,
          unit: details.unit,
          ip_quantity_needed: details.ip_quantity_needed,
          ip_quantity_on_site: details.ip_quantity_on_site
        };
      });
    }

    const updateObj = {
      pharm_add_same_as_site: supplyOrder.pharm_add_same_as_site,
      pharm_name: supplyOrder.pharm_name,
      pharm_id: supplyOrder.pharm_id,
      pharm_nick_name: supplyOrder.pharm_nick_name,
      pharm_street_address: supplyOrder.pharm_street_address,
      pharm_street_address2: supplyOrder.pharm_street_address2,
      pharm_city: supplyOrder.pharm_city,
      pharm_country: supplyOrder.pharm_country,
      pharm_zip_code: supplyOrder.pharm_zip_code,
      ip_overnight: supplyOrder.ip_overnight,
      ip_delivery_date: supplyOrder.ip_delivery_date,
      ip_requested_by: supplyOrder.ip_requested_by,
      ip_requested_date: supplyOrder.ip_requested_date,
      ip_ordered_by: supplyOrder.ip_ordered_by,
      ip_ordered_date: supplyOrder.ip_ordered_date,
      ip_sign_personnel: supplyOrder.ip_sign_personnel,
      ip_sponsor_received_by: supplyOrder.ip_sponsor_received_by,
      ip_sponsor_received_date: supplyOrder.ip_sponsor_received_date,
      ip_sponsor_received_signature: supplyOrder.ip_sponsor_received_signature,
      ip_sponsor_reviewed_by: supplyOrder.ip_sponsor_reviewed_by,
      ip_sponsor_reviewed_date: supplyOrder.ip_sponsor_reviewed_date,
      ip_sponsor_reviewed_signature: supplyOrder.ip_sponsor_reviewed_signature,
      ip_sponsor_reviewed_signature_reason: supplyOrder.ip_sponsor_reviewed_signature_reason,
      ip_sponsor_received_signature_reason: supplyOrder.ip_sponsor_received_signature_reason,
      ip_open_label: supplyOrder.ip_open_label === 'Yes' ? true : supplyOrder.ip_open_label === 'No' ? false : null,
      treatment_number: supplyOrder.treatment_number,
      ip_site_signed_by: supplyOrder.ip_site_signed_by,
      ip_site_signature: supplyOrder.ip_site_signature,
      ip_site_signature_reason: supplyOrder.ip_site_signature_reason,
      ip_site_signed_date: supplyOrder.ip_site_signed_date,
      id: supplyOrder.id
    };
    if (isUpdate) {
      if (openResupplyOrder) {
        await updateIpResupplyOrder({
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry,
          ip_resupply_id: selectResupplyData?.id,
          application: archLevel === 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP,
          application_section: currentApp,
          data: {
            ...updateObj,
            updated_by: user,
            investigational_drug_details: invDrugDetails.map((ele: any) => {
              if (ele.id) {
                return { ...ele, study_investigational_id: ele.id };
              } else {
                return ele;
              }
            })
          }
        });
      } else {
        await updateIpSupplyOrder({
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry,
          application: process.env.REACT_APP_NAME_TEMP,
          application_section: currentApp,
          data: {
            ...updateObj,
            updated_by: user,
            investigational_drug_details: invDrugDetails.map((ele: any) => {
              if (ele.id) {
                return { ...ele, study_investigational_id: ele.id };
              } else {
                return ele;
              }
            })
          }
        });
      }
    } else {
      await createIpSupplyOrder({
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,
        application: archLevel === 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP,
        application_section: currentApp,
        data: { ...supplyOrder, created_by: user, investigational_drug_details: invDrugDetails }
      });
    }
  };

  useEffect(() => {
    getIpSupplyDetailsQueryData();
    getStudySitePersonnelQueryData({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application: process.env.REACT_APP_NAME,
      site_users: true,
      strictly_site_users: true
    });
    if (!isNewResupply || !openResupplyOrder) {
      getIpSupplyOrderQueryData();
    } else if (selectResupplyData?.id) {
      selectIpResupplyFunc();
    }
  }, [selectedSite]);

  const appendNewIPProfile = async () => {
    setConfirmExitValue(dispatch, true);
    const templistOfIpProfile = ipDrugDetails;
    const newIpProfileAdded = {
      id: crypto.randomUUID(),
      ...initialIPDrugDetail
    };
    setIpDrugDetails([...templistOfIpProfile, newIpProfileAdded]);
    setIsSupplyChanged(true);
  };
  const ipHandleCheck = (unique_id: number, e: any) => {
    const data = e?.target?.value;
    const findDrug = ipDrugDetails.find((item: any) => item.investigational_drug === data);
    if (findDrug && e.target.name == 'investigational_drug') {
      dispatch(setMessage({ msgDetails: 'Custom Name already Exists.', severity: 'error' }));
    } else {
      dispatch(clearMessage());
      const iPDrugsData = ipDrugDetails.map((item: any) => {
        if (item.id === unique_id) {
          if (e.target.name == 'investigational_drug') {
            data == null || data == '' ? (item.isErrorIPDrug = true) : (item.isErrorIPDrug = false);
          } else if (e.target.name == 'unit') {
            data == null || data == '' ? (item.isErrorUnit = true) : (item.isErrorUnit = false);
          } else if (e.target.name == 'ip_quantity_needed') {
            data == null || data == '' ? (item.isErrorIPQtyNeeded = true) : (item.isErrorIPQtyNeeded = false);
          } else if (e.target.name == 'ip_quantity_on_site') {
            data == null || data == '' ? (item.isErrorIPQtyOnsite = true) : (item.isErrorIPQtyOnsite = false);
          }
          return {
            ...item,
            [e.target.name]: e.target.value
          };
        } else {
          return item;
        }
      });
      setIpDrugDetails(iPDrugsData);
      setIsIPSupplySaved(false);
      setConfirmExitValue(dispatch, true);
      setIsSupplyChanged(true);
    }
  };

  const handleDeleteIPProfile = (Id: number) => {
    setDeleteOpen(true);
    setRemoveIpID(Id);
  };

  const handleDeleteSubmit = () => {
    const newIpDrug = ipDrugDetails.filter((obj: any) => obj.id != removeIpID);
    setIpDrugDetails(newIpDrug);
    setDeleteOpen(false);
    setIsSupplyChanged(true);
  };
  const handleDeleteClose = () => {
    setDeleteOpen(false);
  };

  const handleSiteSign = () => {
    setOpenSignConsent(true);
    setSignControlObject({
      ...signControlObject,
      is_receivedby_sign: false,
      is_reviewedby_sign: false,
      is_site_sign: true
    });
  };

  useEffect(() => {
    if (getIpSupplyOrderIsError || updateIpSupplyOrderIsError || createIpSupplyOrderIsError) {
      const dataErorr: any = createIpSupplyOrderIsError
        ? createIpSupplyOrderError
        : updateIpSupplyOrderIsError
        ? updateIpSupplyOrderError
        : getIpSupplyOrderIsError
        ? getIpSupplyOrderError
        : null;
      if (dataErorr?.status == 500) {
        dispatch(
          setMessage({
            msgDetails: `${dataErorr?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (dataErorr?.status == 422) {
        const error = dataErorr?.data?.context?.message || 'Invalid Details';
        dispatch(
          setMessage({
            msgDetails: error,
            severity: 'error'
          })
        );
      } else if (dataErorr?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: 'Error 403 Restricted User permission',
            severity: 'error'
          })
        );
      }
    }
  }, [getIpSupplyOrderIsError, updateIpSupplyOrderIsError, createIpSupplyOrderIsError]);
  useEffect(() => {
    if (
      getIpSupplyDetailsLoading ||
      getIpSupplyOrderLoading ||
      updateIpSupplyOrderLoading ||
      createIpSupplyOrderLoading ||
      getdownloadCSVLoading ||
      updateIpResupplyOrderLoading
    ) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [
    getIpSupplyDetailsLoading,
    getIpSupplyOrderLoading,
    updateIpSupplyOrderLoading,
    createIpSupplyOrderLoading,
    getdownloadCSVLoading,
    updateIpResupplyOrderLoading
  ]);

  useEffect(() => {
    if (updateIpSupplyOrderSuccess || createIpSupplyOrderIsSuccess) {
      dispatchApp(setMessage({ msgDetails: ipmDataUpdateSuccessMsg, severity: 'success' }));
      setIsSupplyChanged(false);
      setIsIPSupplySaved(true);
      if (isNewResupply) {
        dispatch(setOpenResupplyOrderPage(false));
        dispatch(setNewResupplyOrder(false));
        dispatch(setSelectedResupply({}));
      } else {
        getIpSupplyOrderQueryData();
      }
      createIpSupplyOrderIsSuccess && setIsUpdate(true);
    }
  }, [updateIpSupplyOrderSuccess, createIpSupplyOrderIsSuccess]);

  useEffect(() => {
    if (updateIpResupplyOrderSuccess) {
      dispatchApp(setMessage({ msgDetails: ipmDataUpdateSuccessMsg, severity: 'success' }));
      setIsSupplyChanged(false);
      setIsIPSupplySaved(true);
      selectIpResupplyFunc();
      updateIpResupplyOrderSuccess && setIsUpdate(true);
    }
  }, [updateIpResupplyOrderSuccess]);

  const printIPSupplyOrder = async () => {
    try {
      dispatch(showLoader());
      const options = {
        monitoring_visit_id: currentApp === 'STARTUP' ? supplyOrder?.id : selectResupplyData?.id,
        template_name: 'Investigational_product_supply_order',
        study_id: studyId,
        site_id: selectedSite,
        pathVariables: {
          time_zone_id: UI_TIME_ZONE,
          country: selectedCountry,
          appName: archLevel === 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP,
          application_section: currentApp
        }
      };
      printPdfWithViewer('get_IPSupplyOrder_pdf_file', options, 'application/pdf');
      setTimeout(() => {
        dispatch(hideLoader());
      }, 1500);
    } catch (error: any) {
      dispatch(hideLoader());
      showError('Error while fetching pdf');
    }
    //setConfirmExitValue(dispatch, false);
  };

  const onConfirmPrimaryPharmacy = () => {
    setContext(false);
    setPrimaryPharmacyDetails();
  };

  const handleSiteSubmit = () => {
    setOpenSubmitModal(true);
  };

  const handleSponsorSubmit = () => {
    setOpenSponsorSubmitModal(true);
  };

  const handleApproveSubmit = async () => {
    await approveSubmitIPSuply({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      ip_supply_id: supplyOrder?.id,
      application: 'TSDA',
      application_section: currentApp,
      data: { is_sponsor_approved: true, status: 'Approved' }
    });
  };

  useEffect(() => {
    if (approveSubmitIsSuccess) {
      selectIpResupplyFunc();
      const sucessMessage = `${
        selectIpResupplyData?.order_number
      } was approved.Submitted by ${user} ${getPreferredDateTimeInLocal(selectIpResupplyData?.updated_on)}`;
      dispatchApp(setMessage({ msgDetails: sucessMessage, severity: 'success' }));
      setOpenSponsorSubmitModal(false);
      window.scrollTo(0, 0);
    }
  }, [approveSubmitIsSuccess]);

  const alertMessage =
    archLevel == 'sponsor'
      ? ['approved', supplyOrder?.updated_by, getPreferredDateTimeInLocal(supplyOrder?.updated_on)]
      : ['created', supplyOrder?.submitted_by, getPreferredDateTimeInLocal(supplyOrder?.submitted_on)];

  return (
    <>
      {(archLevel == 'sponsor' ? supplyOrder?.is_sponsor_approved : supplyOrder?.order_number) && (
        <Alert
          id="orderAlert"
          sx={{ mt: 1 }}
          action={
            <>
              <Button color="inherit" onClick={getDownLoadCSV} sx={{ mr: 1, minWidth: 'fit-content' }}>
                Download CSV File
              </Button>
              <Tooltip title="Print" placement="top" arrow>
                <IconButton onClick={printIPSupplyOrder} sx={{ mr: 1 }}>
                  <LocalPrintshopIcon />
                </IconButton>
              </Tooltip>
            </>
          }
          iconMapping={{
            success: <CheckCircleOutlineIcon fontSize="inherit" />
          }}
        >
          <>
            Order <strong>{supplyOrder?.order_number}</strong> was {alertMessage?.[0]}.{' '}
            <div className="showBlockinHD">
              Submitted by <strong>{alertMessage?.[1]}</strong> on {alertMessage?.[2]}
            </div>
          </>
        </Alert>
      )}
      <Grid container>
        <Grid container>
          <Grid md={3}>
            <Item>
              <FormControl fullWidth margin="normal">
                <TextField
                  id="standard-basic"
                  label={ipSupplyOrder.label1}
                  variant="standard"
                  name="site_id"
                  value={supplyDetails.site_id || ''}
                  disabled
                />
              </FormControl>
            </Item>
          </Grid>
          <Grid md={3}>
            <Item>
              <FormControl fullWidth margin="normal">
                <TextField
                  id="standard-basic"
                  label={ipSupplyOrder.label2}
                  variant="standard"
                  name="pi_name"
                  value={supplyDetails.pi_name || ''}
                  disabled
                />
              </FormControl>
            </Item>
          </Grid>
          <Grid md={3}>
            <Item>
              <FormControl fullWidth margin="normal">
                <TextField
                  id="standard-basic"
                  label={ipSupplyOrder.label3}
                  variant="standard"
                  name="pharmacist_name"
                  value={supplyDetails.pharmacist_name || ''}
                  disabled
                />
              </FormControl>
            </Item>
          </Grid>
          <Grid md={3}>
            <Item>
              <FormControl fullWidth margin="normal">
                <TextField
                  id="standard-basic"
                  label={ipSupplyOrder.label4}
                  variant="standard"
                  name="pharmacist_phone_number"
                  value={supplyDetails.pharmacist_phone_number || ''}
                  disabled
                />
              </FormControl>
            </Item>
          </Grid>
        </Grid>
        <Grid container>
          <Grid md={12}>
            <h4>{ipSupplyOrder.label5}</h4>
          </Grid>
        </Grid>

        <Grid container>
          <Grid md={12} className="input-action">
            <Item>
              <p>{ipSupplyOrder.label6}?</p>
            </Item>
            <FormControl
              className="radio-buttons-block"
              disabled={
                isSubmitted ||
                !perDisable ||
                isSignsCompleted ||
                supplyOrder?.ip_site_signed_by ||
                disableIpSupplyOprder
              }
            >
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="ip_open_label"
                value={supplyOrder.ip_open_label}
                className="radio-buttons"
                onChange={handleCheck}
              >
                <FormControlLabel
                  value="Yes"
                  name="ip_open_label"
                  control={<Radio />}
                  label="Yes"
                  disabled={supplyOrder?.ip_site_signed_by}
                />
                <FormControlLabel
                  value="No"
                  name="ip_open_label"
                  control={<Radio />}
                  label="No"
                  disabled={supplyOrder?.ip_site_signed_by}
                />
              </RadioGroup>
            </FormControl>
            {supplyOrder.ip_open_label === 'Yes' ? (
              <Tooltip
                title={supplyOrder?.treatment_number?.length > 32 ? supplyOrder?.treatment_number : null}
                placement="right"
              >
                <FormControl fullWidth margin="normal">
                  <Item>
                    <TextField
                      id="standard-basic"
                      label="Treatment No."
                      variant="standard"
                      className="treatment-field"
                      name="treatment_number"
                      value={supplyOrder.treatment_number}
                      key={supplyOrder.treatment_number}
                      disabled
                    />
                  </Item>
                </FormControl>
              </Tooltip>
            ) : null}
          </Grid>
        </Grid>

        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Grid md={8}>
            <Stack sx={{ width: '100%', my: 2 }} spacing={2}>
              <Alert severity="info">
                All requests received by 2 PM EST on a weekday will be shipped to arrive by 4:30 PM on the second day.
                Requests pertaining to refrigerated drugs will be shipped by overnight service to arrive by 10 AM on the
                next business day.
              </Alert>
            </Stack>
          </Grid>
        </Grid>
        <Grid container>
          <Grid md={12}>
            <h4>{ipSupplyOrder.label8}</h4>
          </Grid>
          <Grid md={12} className="input-action">
            <Item>
              <p>{ipSupplyOrder.label9}?</p>
            </Item>
            <FormControl className="radio-buttons-block">
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="pharm_add_same_as_site"
                className="radio-buttons"
                value={supplyOrder.pharm_add_same_as_site}
                onChange={handleRadio}
              >
                <FormControlLabel
                  value="Y"
                  checked={supplyOrder.pharm_add_same_as_site === 'Y' ? true : false}
                  name="pharm_add_same_as_site"
                  control={<Radio />}
                  label="Yes"
                  disabled={
                    isSubmitted ||
                    !perDisable ||
                    isSignsCompleted ||
                    supplyOrder?.ip_site_signed_by ||
                    disableIpSupplyOprder
                  }
                />
                <FormControlLabel
                  value="N"
                  checked={supplyOrder.pharm_add_same_as_site === 'N' ? true : false}
                  name="pharm_add_same_as_site"
                  control={<Radio />}
                  label="No"
                  disabled={
                    isSubmitted ||
                    !perDisable ||
                    isSignsCompleted ||
                    supplyOrder?.ip_site_signed_by ||
                    disableIpSupplyOprder
                  }
                />
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>

        <Grid container>
          <Grid md={9.6}>
            <Item>
              <Tooltip
                title={
                  supplyOrder?.pharm_nick_name?.length > 2
                    ? `${supplyOrder?.pharm_name} - ${supplyOrder?.pharm_nick_name}`
                    : null
                }
                placement="top"
              >
                <FormControl
                  fullWidth
                  margin="normal"
                  className="left-align"
                  sx={{ '& .MuiOutlinedInput-input': { paddingRight: '32px !important' } }}
                  disabled={
                    supplyOrder.pharm_add_same_as_site === 'Y' ||
                    supplyOrder.pharm_add_same_as_site === 'NA' ||
                    supplyOrder.pharm_add_same_as_site === null ||
                    isSubmitted ||
                    !perDisable ||
                    isSignsCompleted ||
                    supplyOrder?.ip_site_signed_by ||
                    disableIpSupplyOprder
                  }
                >
                  <InputLabel id="invest_prod-label">Pharmacy</InputLabel>

                  <Select
                    labelId="invest_prod-label"
                    id="invest_prod"
                    value={pharmacyDropdownName}
                    onChange={e => onPharmacyNameChange(e)}
                    input={<OutlinedInput label="Investigational Product" />}
                    name="pharmacy_list"
                  >
                    {(supplyOrder.pharm_add_same_as_site === 'Y' ? primaryPharmacyData : pharmacyAddressList)?.map(
                      (value: any) => (
                        <MenuItem
                          key={value.pharm_name}
                          value={value.pharm_name}
                          sx={{
                            whiteSpace: 'normal !important',
                            wordBreak: 'break-word',
                            '@media (min-width:1680px)': {
                              maxWidth: '1040px'
                            },
                            '@media (max-width:1670px)': {
                              maxWidth: '880px'
                            },
                            '@media (max-width:1440px)': {
                              maxWidth: '720px'
                            },
                            '@media (max-width:1366px)': {
                              maxWidth: '660px'
                            }
                          }}
                        >
                          {`${value.pharm_name}${value.pharm_nick_name ? ` - ${value.pharm_nick_name}` : ''}`}
                        </MenuItem>
                      )
                    )}
                  </Select>
                </FormControl>
              </Tooltip>
            </Item>
          </Grid>
        </Grid>

        <Grid container className="pharmacy-address">
          {pharmacyDropdownName === 'Other' && supplyOrder.pharm_id === null && (
            <Grid md={12}>
              <Item>
                <Tooltip title={supplyOrder?.pharm_name?.length > 110 ? supplyOrder?.pharm_name : null} placement="top">
                  <FormControl fullWidth margin="normal">
                    <TextField
                      id="standard-basic"
                      label={ipSupplyOrder.label32}
                      variant="standard"
                      name="pharm_name"
                      required
                      value={supplyOrder.pharm_name}
                      inputProps={{ maxLength: 100 }}
                      onChange={handleCheck}
                      error={pharmNameIsError}
                      helperText={pharmNameIsError && 'Required'}
                      disabled={
                        isSubmitted ||
                        !perDisable ||
                        isSignsCompleted ||
                        supplyOrder?.ip_site_signed_by ||
                        disableIpSupplyOprder
                      }
                    />
                  </FormControl>
                </Tooltip>
              </Item>
            </Grid>
          )}
          <Grid md={6}>
            <Item>
              <Tooltip
                title={supplyOrder?.pharm_street_address?.length > 56 ? supplyOrder?.pharm_street_address : null}
                placement="top"
              >
                <FormControl fullWidth margin="normal">
                  <TextField
                    id="standard-basic"
                    label={ipSupplyOrder.label10}
                    variant="standard"
                    name="pharm_street_address"
                    value={supplyOrder.pharm_street_address}
                    inputProps={{ maxLength: 100 }}
                    onChange={handleCheck}
                    disabled={
                      supplyOrder.pharm_add_same_as_site === 'Y' ||
                      !(
                        supplyOrder.pharm_add_same_as_site === 'N' &&
                        pharmacyDropdownName === 'Other' &&
                        !supplyOrder.pharm_id
                      ) ||
                      isSubmitted ||
                      !perDisable ||
                      isSignsCompleted ||
                      supplyOrder?.ip_site_signed_by ||
                      disableIpSupplyOprder
                    }
                  />
                </FormControl>
              </Tooltip>
            </Item>
          </Grid>

          <Grid md={6}>
            <Item>
              <Tooltip
                title={supplyOrder?.pharm_street_address2?.length > 56 ? supplyOrder?.pharm_street_address2 : null}
                placement="top"
              >
                <FormControl fullWidth margin="normal">
                  <TextField
                    id="standard-basic"
                    label={ipSupplyOrder.label11}
                    variant="standard"
                    name="pharm_street_address2"
                    value={supplyOrder.pharm_street_address2}
                    inputProps={{ maxLength: 100 }}
                    disabled={
                      supplyOrder.pharm_add_same_as_site === 'Y' ||
                      !(
                        supplyOrder.pharm_add_same_as_site === 'N' &&
                        pharmacyDropdownName === 'Other' &&
                        !supplyOrder.pharm_id
                      ) ||
                      isSubmitted ||
                      !perDisable ||
                      isSignsCompleted ||
                      supplyOrder?.ip_site_signed_by ||
                      disableIpSupplyOprder
                    }
                    onChange={handleCheck}
                  />
                </FormControl>
              </Tooltip>
            </Item>
          </Grid>
          <Grid md={4}>
            <Item>
              <Tooltip title={supplyOrder?.pharm_city?.length > 30 ? supplyOrder?.pharm_city : null} placement="top">
                <FormControl fullWidth margin="normal">
                  <TextField
                    id="standard-basic"
                    label={ipSupplyOrder.label12}
                    variant="standard"
                    name="pharm_city"
                    value={supplyOrder.pharm_city}
                    inputProps={{ maxLength: 50 }}
                    disabled={
                      supplyOrder.pharm_add_same_as_site === 'Y' ||
                      !(
                        supplyOrder.pharm_add_same_as_site === 'N' &&
                        pharmacyDropdownName === 'Other' &&
                        !supplyOrder.pharm_id
                      ) ||
                      isSubmitted ||
                      !perDisable ||
                      isSignsCompleted ||
                      supplyOrder?.ip_site_signed_by ||
                      disableIpSupplyOprder
                    }
                    onChange={handleCheck}
                  />
                </FormControl>
              </Tooltip>
            </Item>
          </Grid>
          <Grid md={4}>
            <Item>
              <Tooltip
                title={supplyOrder?.pharm_country?.length > 30 ? supplyOrder?.pharm_country : null}
                placement="top"
              >
                <FormControl fullWidth margin="normal" disabled={disableIpSupplyOprder}>
                  <TextField
                    id="standard-basic"
                    label={ipSupplyOrder.label13}
                    variant="standard"
                    name="pharm_country"
                    inputProps={{ maxLength: 50 }}
                    value={supplyOrder.pharm_country}
                    disabled={
                      supplyOrder.pharm_add_same_as_site === 'Y' ||
                      !(
                        supplyOrder.pharm_add_same_as_site === 'N' &&
                        pharmacyDropdownName === 'Other' &&
                        !supplyOrder.pharm_id
                      ) ||
                      isSubmitted ||
                      !perDisable ||
                      isSignsCompleted ||
                      supplyOrder?.ip_site_signed_by ||
                      disableIpSupplyOprder
                    }
                    onChange={handleCheck}
                  />
                </FormControl>
              </Tooltip>
            </Item>
          </Grid>
          <Grid md={4}>
            <Item>
              <Tooltip
                title={supplyOrder?.pharm_zip_code?.length > 30 ? supplyOrder?.pharm_zip_code : null}
                placement="top"
              >
                <FormControl fullWidth margin="normal">
                  <TextField
                    id="standard-basic"
                    label={ipSupplyOrder.label14}
                    variant="standard"
                    name="pharm_zip_code"
                    value={supplyOrder.pharm_zip_code}
                    inputProps={{ maxLength: 50 }}
                    disabled={
                      supplyOrder.pharm_add_same_as_site === 'Y' ||
                      !(
                        supplyOrder.pharm_add_same_as_site === 'N' &&
                        pharmacyDropdownName === 'Other' &&
                        !supplyOrder.pharm_id
                      ) ||
                      isSubmitted ||
                      !perDisable ||
                      isSignsCompleted ||
                      supplyOrder?.ip_site_signed_by ||
                      disableIpSupplyOprder
                    }
                    onChange={handleCheck}
                  />
                </FormControl>
              </Tooltip>
            </Item>
          </Grid>
        </Grid>
        <Grid container>
          <Grid md={12}>
            <h4>Investigational Product Quantity</h4>
          </Grid>
        </Grid>

        {ipDrugDetails.length > 0 &&
          ipDrugDetails.map((ele: any) => {
            return (
              <Grid container mb={1} ml={0.25} spacing={0} key={ele.id}>
                <>
                  <Grid md={3.15}>
                    <Item>
                      <Tooltip
                        title={ele?.investigational_drug?.length > 20 ? ele?.investigational_drug : null}
                        placement="top"
                      >
                        <FormControl
                          fullWidth
                          margin="normal"
                          className="left-align"
                          error={ele?.isErrorIPDrug}
                          sx={{ '& .MuiOutlinedInput-input': { paddingRight: '32px !important' } }}
                        >
                          <InputLabel id="invest_prod-label" required>
                            Custom Name
                          </InputLabel>
                          <Select
                            sx={{ maxWidth: '100%' }}
                            labelId="invest_prod-label"
                            id="invest_prod"
                            value={ele.investigational_drug}
                            required
                            onChange={e => ipHandleCheck(ele.id, e)}
                            input={<OutlinedInput label="Custom Name" />}
                            name="investigational_drug"
                            disabled={
                              isSubmitted ||
                              !perDisable ||
                              isSignsCompleted ||
                              supplyOrder?.ip_site_signed_by ||
                              disableIpSupplyOprder
                            }
                          >
                            {drugNames?.map((value: any) => (
                              <MenuItem key={value} value={value}>
                                {value}
                              </MenuItem>
                            ))}
                          </Select>
                          {ele?.isErrorIPDrug && <FormHelperText className="Mui-error">Required</FormHelperText>}
                        </FormControl>
                      </Tooltip>
                    </Item>
                  </Grid>
                  <Grid md={2.75}>
                    <Item>
                      <FormControl fullWidth margin="normal" className="left-align" error={ele.isErrorUnit}>
                        <InputLabel id="qunatunit-label" required>
                          Quantity Unit
                        </InputLabel>
                        <Select
                          labelId="qunatunit-label"
                          id="qunatunit"
                          value={ele.unit}
                          onChange={e => ipHandleCheck(ele.id, e)}
                          input={<OutlinedInput label="Quantity Unit" />}
                          required
                          name="unit"
                          disabled={
                            isSubmitted ||
                            !perDisable ||
                            isSignsCompleted ||
                            supplyOrder?.ip_site_signed_by ||
                            disableIpSupplyOprder
                          }
                        >
                          {equipmentData?.map((value: any) => (
                            <MenuItem key={value} value={value}>
                              {value}
                            </MenuItem>
                          ))}
                        </Select>
                        {ele.isErrorUnit && <FormHelperText className="Mui-error">Required</FormHelperText>}
                      </FormControl>
                    </Item>
                  </Grid>
                  <Grid md={2.75} mt={-0.5}>
                    <Item>
                      <FormControl fullWidth margin="normal">
                        <TextField
                          id="standard-basic"
                          label="Quantity Needed"
                          variant="standard"
                          value={ele.ip_quantity_needed}
                          name="ip_quantity_needed"
                          required
                          type="number"
                          placeholder="Only numbers allowed."
                          error={ele?.isErrorIPQtyNeeded}
                          helperText={ele?.isErrorIPQtyNeeded && 'Required'}
                          InputProps={{ inputProps: { min: 0, max: 999, maxLength: 3 } }}
                          onInput={(e: any) => {
                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 3);
                          }}
                          onChange={e => ipHandleCheck(ele.id, e)}
                          disabled={
                            isSubmitted ||
                            !perDisable ||
                            isSignsCompleted ||
                            supplyOrder?.ip_site_signed_by ||
                            disableIpSupplyOprder
                          }
                        />
                      </FormControl>
                    </Item>
                  </Grid>
                  <Grid md={2.75} mt={-0.5}>
                    <Item>
                      <FormControl fullWidth margin="normal">
                        <TextField
                          id="standard-basic"
                          label="Quantity on Site"
                          variant="standard"
                          value={ele.ip_quantity_on_site}
                          name="ip_quantity_on_site"
                          type="number"
                          required
                          error={ele?.isErrorIPQtyOnsite}
                          helperText={ele?.isErrorIPQtyOnsite && 'Required'}
                          placeholder="Only numbers allowed."
                          InputProps={{ inputProps: { min: 0, max: 999, maxLength: 3 } }}
                          onInput={(e: any) => {
                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 3);
                          }}
                          onChange={e => ipHandleCheck(ele.id, e)}
                          disabled={
                            isSubmitted ||
                            !perDisable ||
                            isSignsCompleted ||
                            supplyOrder?.ip_site_signed_by ||
                            disableIpSupplyOprder
                          }
                        />
                      </FormControl>
                    </Item>
                  </Grid>
                  <Grid md={0.6} item display="flex" justifyContent="end">
                    <IconButton
                      className="delete-card-icon"
                      onClick={() => handleDeleteIPProfile(ele.id)}
                      sx={{ mt: 2 }}
                      disabled={
                        !checkPermission('update_ip_supply_order') ||
                        ipDrugDetails?.length <= 1 ||
                        isSubmitted ||
                        isSignsCompleted ||
                        supplyOrder?.ip_site_signed_by ||
                        disableIpSupplyOprder
                      }
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Grid>
                </>
              </Grid>
            );
          })}

        <Button
          disabled={
            !checkPermission('update_ip_supply_order') ||
            isSubmitted ||
            isSignsCompleted ||
            supplyOrder?.ip_site_signed_by ||
            disableIpSupplyOprder
          }
          startIcon={<AddIcon />}
          onClick={appendNewIPProfile}
        >
          Add Investigational Product
        </Button>

        <Grid container>
          <Grid md={12}>
            <h4>{ipSupplyOrder.label18}</h4>
          </Grid>
        </Grid>

        <Grid container>
          <Grid md={6} className="input-action">
            <Item>
              <p>{ipSupplyOrder.label20}</p>
            </Item>
            <Grid md={3.5}>
              <FormControl className="radio-buttons-block">
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="ip_overnight"
                  value={supplyOrder.ip_overnight}
                  className="radio-buttons"
                  onChange={handleCheck}
                >
                  <FormControlLabel
                    value="Y"
                    name="ip_overnight"
                    disabled={
                      isSubmitted ||
                      !perDisable ||
                      isSignsCompleted ||
                      supplyOrder?.ip_site_signed_by ||
                      disableIpSupplyOprder
                    }
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    value="N"
                    name="ip_overnight"
                    disabled={
                      isSubmitted ||
                      !perDisable ||
                      isSignsCompleted ||
                      supplyOrder?.ip_site_signed_by ||
                      disableIpSupplyOprder
                    }
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid md={2} />
            <FormControl fullWidth margin="normal" sx={{ maxWidth: 250 }}>
              <Item>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <Stack spacing={3} className="custom-date delivery-date">
                    <DatePicker
                      disableFuture={false}
                      label="Date"
                      inputFormat={datePickerInputFormat}
                      value={supplyOrder.ip_delivery_date}
                      onChange={newValue => {
                        let changedDate;
                        if (newValue) {
                          changedDate = getServerDateOrInvalidDayJs(newValue);
                        } else {
                          changedDate = newValue;
                        }
                        setSupplyOrder({
                          ...supplyOrder,
                          ip_delivery_date: changedDate
                        });
                        changedDate && changedDate === 'Invalid Date'
                          ? setipDeliveryDateError(true)
                          : setipDeliveryDateError(false);
                        setIsIPSupplySaved(false);
                        setIsSupplyChanged(true);
                        setConfirmExitValue(dispatch, true);
                      }}
                      disabled={
                        supplyOrder.ip_overnight == 'Y' ||
                        isSubmitted ||
                        !perDisable ||
                        isSignsCompleted ||
                        supplyOrder?.ip_site_signed_by ||
                        disableIpSupplyOprder
                      }
                      renderInput={params => <TextField {...params} error={ipDeliveryDateError} />}
                    />
                  </Stack>
                </LocalizationProvider>
              </Item>
            </FormControl>
          </Grid>
        </Grid>
        <Grid container>
          <Grid md={2}>
            <Item>
              <FormControl className="left-align">
                <InputLabel id="demo-simple-select-label">Requested By</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select-labele"
                  value={supplyOrder.ip_requested_by}
                  onChange={handleCheck}
                  input={<OutlinedInput label={ipSupplyOrder.label21} />}
                  name="ip_requested_by"
                  disabled={
                    isSubmitted ||
                    !perDisable ||
                    isSignsCompleted ||
                    supplyOrder?.ip_site_signed_by ||
                    disableIpSupplyOprder
                  }
                >
                  {getRequestedBy?.personnel?.map((option: any) => (
                    <MenuItem key={option.id} value={`${option.site_per_first_name} ${option.site_per_last_name}`}>
                      {`${option.site_per_first_name} ${option.site_per_last_name}`}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Item>
          </Grid>
          <Grid md={3} mt={-0.5}>
            <Item>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Stack spacing={0} className="custom-date">
                  <DatePicker
                    label={ipSupplyOrder.label22}
                    inputFormat={datePickerInputFormat}
                    value={supplyOrder.ip_requested_date}
                    disabled={
                      isSubmitted ||
                      !perDisable ||
                      isSignsCompleted ||
                      supplyOrder?.ip_site_signed_by ||
                      disableIpSupplyOprder
                    }
                    onChange={newValue => {
                      let changedDate;
                      if (newValue) {
                        changedDate = getServerDateOrInvalidDayJs(newValue);
                      } else {
                        changedDate = newValue;
                      }
                      setSupplyOrder({
                        ...supplyOrder,
                        ip_requested_date: changedDate
                      });
                      setIsIPSupplySaved(false);
                      setIsSupplyChanged(true);
                      setConfirmExitValue(dispatch, true);
                    }}
                    renderInput={params => <TextField {...params} error={ipRequestedDate} />}
                  />
                </Stack>
              </LocalizationProvider>
            </Item>
          </Grid>

          <Grid container>
            <Grid md={2}>
              <Item>
                <FormControl fullWidth margin="normal" className="left-align">
                  <InputLabel id="demo-simple-select-label">Ordered By</InputLabel>
                  <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select"
                    value={supplyOrder.ip_ordered_by}
                    onChange={handleCheck}
                    input={<OutlinedInput label={ipSupplyOrder.label23} />}
                    name="ip_ordered_by"
                    MenuProps={{
                      anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left'
                      },
                      transformOrigin: {
                        vertical: 'top',
                        horizontal: 'left'
                      }
                    }}
                    disabled={
                      isSubmitted ||
                      !perDisable ||
                      isSignsCompleted ||
                      supplyOrder?.ip_site_signed_by ||
                      disableIpSupplyOprder
                    }
                  >
                    {getOrderBy?.personnel?.map((option: any) => (
                      <MenuItem key={option.id} value={`${option.site_per_first_name} ${option.site_per_last_name}`}>
                        {`${option.site_per_first_name} ${option.site_per_last_name}`}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Item>
            </Grid>
            <Grid md={3} mt={-0.5}>
              <Item>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <Stack spacing={3} className="custom-date">
                    <DatePicker
                      label={ipSupplyOrder.label24}
                      inputFormat={datePickerInputFormat}
                      value={supplyOrder.ip_ordered_date}
                      onChange={newValue => {
                        let changedDate;
                        if (newValue) {
                          changedDate = getServerDateOrInvalidDayJs(newValue);
                        } else {
                          changedDate = newValue;
                        }
                        setSupplyOrder({
                          ...supplyOrder,
                          ip_ordered_date: changedDate
                        });
                        setIsIPSupplySaved(false);
                        setIsSupplyChanged(true);
                        setConfirmExitValue(dispatch, true);
                      }}
                      renderInput={params => <TextField {...params} error={ipOrderedDate} />}
                      disabled={
                        isSubmitted ||
                        !perDisable ||
                        isSignsCompleted ||
                        supplyOrder?.ip_site_signed_by ||
                        disableIpSupplyOprder
                      }
                    />
                  </Stack>
                </LocalizationProvider>
              </Item>
            </Grid>
          </Grid>
          <Grid md={3} />
        </Grid>
        {archLevel == 'site' && (
          <Grid container spacing={2} sx={{ pl: 1.25, mt: 0.5 }}>
            <Grid item md={12}>
              {supplyOrder?.ip_site_signed_by ? (
                <span className="signedInfo">
                  Signed by <strong>{supplyOrder?.ip_site_signed_by}</strong> on{' '}
                  <span color="text.secondary">{`${getPreferredDateTimeInLocal(
                    supplyOrder?.ip_site_signed_date
                  )}`}</span>{' '}
                  <br />
                  <span color="text.secondary">Reason:</span> &ldquo;{supplyOrder?.ip_site_signature_reason}
                  &rdquo;
                </span>
              ) : (
                <Button
                  variant="contained"
                  size="small"
                  onClick={handleSiteSign}
                  disabled={
                    archLevel === 'sponsor' ||
                    !checkPermission('sign_ip_supply_order_site') ||
                    !supplyOrder?.investigational_drug_details?.length ||
                    isSubmitted ||
                    isIPSupplyChanged
                  }
                >
                  Sign
                </Button>
              )}
            </Grid>
          </Grid>
        )}
        {archLevel === 'sponsor' && (
          <>
            <Grid container>
              <Grid md={12}>
                <h4>{ipSupplyOrder.label26}</h4>
              </Grid>
            </Grid>

            <Grid container spacing={2} sx={{ pl: 1.25, mt: 0.5 }}>
              <Grid item md={3} sx={{ fontSize: 'clamp(15px, 1rem, 16px)' }}>
                Request Received By:
              </Grid>
              <Grid item md={9}>
                {supplyOrder?.ip_sponsor_received_by ? (
                  <span className="signedInfo">
                    Signed by <strong>{supplyOrder?.ip_sponsor_received_by}</strong> on{' '}
                    <span color="text.secondary">{`${getPreferredDateTimeInLocal(
                      supplyOrder?.ip_sponsor_received_date
                    )}`}</span>{' '}
                    <br />
                    <span color="text.secondary">Reason:</span> &ldquo;
                    {supplyOrder?.ip_sponsor_received_signature_reason}
                    &rdquo;
                  </span>
                ) : (
                  <Button
                    variant="contained"
                    size="small"
                    onClick={handleReceivedBySignature}
                    disabled={
                      !(
                        checkPermission('sign_ipmanagement_supplyorder_received_by') &&
                        isUpdate &&
                        !isIPSupplyChanged
                      ) || disableSign
                    }
                  >
                    Sign
                  </Button>
                )}
              </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ pl: 1.25, mt: 1 }}>
              <Grid item md={3} sx={{ fontSize: 'clamp(15px, 1rem, 16px)' }}>
                Reviewed By:
              </Grid>
              <Grid item md={9}>
                {supplyOrder?.ip_sponsor_reviewed_by ? (
                  <span className="signedInfo">
                    Signed by <strong>{supplyOrder?.ip_sponsor_reviewed_by}</strong> on{' '}
                    <span color="text.secondary">{`${getPreferredDateTimeInLocal(
                      supplyOrder?.ip_sponsor_reviewed_date
                    )}`}</span>{' '}
                    <br />
                    <span color="text.secondary">Reason:</span> &ldquo;
                    {supplyOrder?.ip_sponsor_reviewed_signature_reason}
                    &rdquo;
                  </span>
                ) : (
                  <Button
                    variant="contained"
                    size="small"
                    onClick={handleReviewedBySignature}
                    disabled={
                      !(
                        checkPermission('sign_ipmanagement_supplyorder_reviewed_by') &&
                        isUpdate &&
                        !isIPSupplyChanged &&
                        supplyOrder?.ip_sponsor_received_by
                      ) || archLevel == 'site'
                    }
                  >
                    Sign
                  </Button>
                )}
              </Grid>
            </Grid>
          </>
        )}

        {checkPermission('update_ip_supply_order') ? (
          <Grid container className="fixed-buttons-block">
            <Grid md={12} display="flex" justifyContent="flex-end">
              <Stack spacing={2} direction="row">
                <Button
                  variant="text"
                  disabled={
                    isSubmitted ||
                    !isIPSupplyChanged ||
                    isSignsCompleted ||
                    supplyOrder?.ip_site_signed_by ||
                    disableIpSupplyOprder
                  }
                  onClick={handleSave}
                >
                  SAVE
                </Button>
              </Stack>
            </Grid>
          </Grid>
        ) : (
          <></>
        )}

        {currentApp == 'CONDUCT' ? (
          <Grid container spacing={2} className="bottom-navigation">
            <Grid item md={12} display="flex" justifyContent="flex-end">
              <Stack spacing={2} direction="row">
                <>
                  {!isSubmitted && archLevel == 'sponsor'
                    ? !supplyOrder?.is_sponsor_approved && (
                        <Button
                          variant="contained"
                          disabled={
                            !checkPermission('review_approve_ip_supplyorder') || !supplyOrder?.ip_sponsor_reviewed_by
                          }
                          onClick={handleSponsorSubmit}
                        >
                          SUBMIT
                        </Button>
                      )
                    : !supplyOrder?.order_number && (
                        <Button
                          variant="contained"
                          disabled={!supplyOrder?.ip_site_signed_by || !checkPermission('update_ip_release')}
                          onClick={handleSiteSubmit}
                        >
                          SUBMIT
                        </Button>
                      )}
                </>
              </Stack>
            </Grid>
          </Grid>
        ) : null}
      </Grid>
      {openSubmitModal && (
        <IpMangementSubmitModal
          openSubmitModal={openSubmitModal}
          setOpenSubmitModal={setOpenSubmitModal}
          user={user}
          ipSupplyOrderQueryData={selectIpResupplyData}
          setSiteSubmitSuccess={setSiteSubmitSuccess}
          currentApp={currentApp}
        />
      )}
      {openSponsorSubmitModal && (
        <AppModal
          open={openSponsorSubmitModal}
          title={'Confirm'}
          saveButton={'OK'}
          closeButton={'CANCEL'}
          handleSubmit={() => handleApproveSubmit()}
          handleClose={() => setOpenSponsorSubmitModal(false)}
          maxWidth="600px"
          outSideClickClose
        >
          <Typography variant="body1" mb="24px">
            Are you sure you want to submit? Additional changes cannot be made once submitted
          </Typography>
        </AppModal>
      )}
      <PopupComponent
        open={context}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="confirm-modal"
        child
      >
        <DialogTitle id="alert-dialog-title">{'Confirm'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Changes you made will not be saved for other Pharmacy
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setContext(false);
            }}
            className="grey-btn"
          >
            Cancel
          </Button>
          <Button onClick={onConfirmPrimaryPharmacy}>Confirm</Button>
        </DialogActions>
      </PopupComponent>

      <PopupComponent
        open={openPharmaConfirmation}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="confirm-modal"
        child
      >
        <DialogTitle id="alert-dialog-title">{'Confirm'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to select a different pharmacy?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenPharmaConfirmation(false);
              setTempPharmDropdownName('');
            }}
            className="grey-btn"
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              setSelectedPharmacyDetails(tempPharmDropdownName);
              setOpenPharmaConfirmation(false);
              setTempPharmDropdownName('');
            }}
          >
            Confirm
          </Button>
        </DialogActions>
      </PopupComponent>

      <PopupComponent aria-labelledby="customized-dialog-title" open={deleteOpen} maxWidth="lg">
        <DialogTitle>Delete Investigational Product</DialogTitle>
        <DialogContent>
          <Typography variant="body1">Are you sure you want to delete the Investigational product added?</Typography>
        </DialogContent>
        <DialogActions>
          <Button className="grey-btn" onClick={handleDeleteClose}>
            No
          </Button>
          <Button onClick={handleDeleteSubmit}>Yes</Button>
        </DialogActions>
      </PopupComponent>
      {openSignConsent && (
        <ESignConsentReAuth
          openSignConsent={openSignConsent}
          setOpenSignConsent={setOpenSignConsent}
          handleConfirmSign={handleIPOrderBySign}
        />
      )}
    </>
  );
};
export default IpSupplyOrderpage;
